import React from "react"

export function Share(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      {...props}
    >
      <path
        d="M0 1.125C0 0.503906 0.503906 0 1.125 0H3.375C3.99609 0 4.5 0.503906 4.5 1.125V1.5H9V1.125C9 0.503906 9.50391 0 10.125 0H12.375C12.9961 0 13.5 0.503906 13.5 1.125V3.375C13.5 3.99609 12.9961 4.5 12.375 4.5H10.125C9.50391 4.5 9 3.99609 9 3.375V3H4.5V3.375C4.5 3.41484 4.49766 3.45469 4.49297 3.49219L6.375 6H8.625C9.24609 6 9.75 6.50391 9.75 7.125V9.375C9.75 9.99609 9.24609 10.5 8.625 10.5H6.375C5.75391 10.5 5.25 9.99609 5.25 9.375V7.125C5.25 7.08516 5.25234 7.04531 5.25703 7.00781L3.375 4.5H1.125C0.503906 4.5 0 3.99609 0 3.375V1.125Z"
        fill="currentColor"
      />
    </svg>
  )
}
